export default "__VITE_ASSET__BfXm2R2K__"